// import third party
import { Box, Flex, Text } from '@chakra-ui/react';

// import local
import ModalConfirmTemplate from '../ui/ModalConfirmTemplate';
import { usePieceStore } from '@pages/UploadMappingV2/hooks/state/useAddProductSatuan';

export default function ModalConfirmAddProductSatuan({ isOpen, onClose, onSubmit }) {
    const { pieces, directPieces, isDirectEditing, isLoading } = usePieceStore();
    const activePieces = isDirectEditing ? directPieces : pieces;
    const totalItems = activePieces.length;

    return (
        <ModalConfirmTemplate
            isOpen={isOpen}
            onClose={onClose}
            isCentered
            isCenterBtn
            onSubmit={onSubmit}
            modalTitle={isDirectEditing ? 'Perbaharui Product' : 'Upload Satuan'}
            width="600px"
            btnTitleCancel="Batalkan"
            isHelperText
            isLoading={isLoading}
        >
            <Flex
                justifyContent={'center'}
                alignItems={'center'}
                flexDir={'column'}
                gap={'8px'}
                py={'16px'}
                textAlign={'center'}
            >
                <Box p={'16px'} borderRadius={'4px'} bgColor={'semantic.200'} mb={'18px'}>
                    <Text fontSize={'26px'} fontWeight={'bold'}>
                        {totalItems} Product
                    </Text>
                    <Text color={'neutral.600'}>{isDirectEditing ? 'Diperbaharui' : 'Terhubung'}</Text>
                </Box>
                <Text maxW={'500px'}>
                    Produk mapping akan menghubungkan kode produk paragon dengan kode produk di toko kamu.
                </Text>
            </Flex>
        </ModalConfirmTemplate>
    );
}
